// To add new glasses:
//
// 1. Add the svg component in this folder.
// 2. Make sure it has the marker ref. (see PositionedGoodyHOC.js for details).
// 2. Import the component here.
// 3. Add the goody to `glassesOptions` here.
// 4. Add the goody to constants.
// 5. Add a new story in src/stories/glasses.js.

import React from 'react';

import PositionedGoodyParentHOC from '../PositionedGoodyParentHOC';

import { POSITIONED_GOODY_REFS } from '../../../../constants';

import Raybans from './Raybans';
import CatEye from './CatEye';
import ThreeD from './ThreeD';
import OldMan from './OldMan';
import Scuba from './Scuba';
import Kerry from './Kerry';
import Blue from './Blue';
import Sunglasses from './Sunglasses';
import Aviators from './Aviators';
import Heart from './Heart';
import Alien from './Alien';

const glassesOptions = {
	'glasses-Raybans': Raybans,
	'glasses-CatEye': CatEye,
	'glasses-ThreeD': ThreeD,
	'glasses-OldMan': OldMan,
	'glasses-Scuba': Scuba,
	'glasses-Kerry': Kerry,
	'glasses-Blue': Blue,
	'glasses-Sunglasses': Sunglasses,
	'glasses-Aviators': Aviators,
	'glasses-Heart': Heart,
	'glasses-Alien': Alien,
};

class Glasses extends PositionedGoodyParentHOC {
	render() {
		const TheseGlasses = glassesOptions[this.props.goody];

		if (!TheseGlasses) {
			return null;
		}

		return (
			<svg ref={POSITIONED_GOODY_REFS.GOODY_CONTAINER} {...this.getPosition()}>
				<TheseGlasses {...this.props} getMarkerCoords={this.getMarkerCoords} />
			</svg>
		);
	}
}

export default Glasses;



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Glasses/_Glasses.js